import Modal from '@components/Modal';
import { isModalOpenAtom, modalChildrenAtom } from '@states//uiAtoms';
import { useAtom, useAtomValue } from 'jotai';

function GlobalModal() {
  const [isOpen, setIsOpen] = useAtom(isModalOpenAtom);
  const children = useAtomValue(modalChildrenAtom);
  return (
      <Modal isOpen={isOpen}
             close={() => setIsOpen(false)}>
          {children}
      </Modal>
  );
}

export default GlobalModal;
